import { useContext } from 'react';
import { WalletAccountContext } from '../context/walletAccountContext';

export function useWalletAccount() {
  const ctx = useContext(WalletAccountContext);
  if (!ctx) {
    throw new Error('useWalletAccount must be used within WalletAccountProvider');
  }
  return ctx;
}
